import { useQuery } from '@tanstack/react-query';

import {
  type components,
  getCustomersByParty,
  type GetCustomersByPartyResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from '../../../../queries/queryKeys';

export default function useCustomers(
  partyId: string,
  filter?: {
    orderBy?: keyof components['schemas']['MinimalUser'];
    sort?: 'asc' | 'desc';
  },
  options?: QueryOptions<GetCustomersByPartyResponse['items']>,
) {
  return useQuery({
    queryKey: queryKeys.customers.list(partyId, filter),
    queryFn: async () => {
      const result = await getCustomersByParty(
        {
          path: { party_id: partyId },
        },
        wgApi,
      );

      return result.items;
    },
    ...options,
  });
}
